import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-left\">\n<g id=\"icon-arrow-left_arrow-left\">\n<path id=\"icon-arrow-left_union\" d=\"M5.87135 12.7472L11.3408 18.2167L10.2801 19.2773L3.3182 12.3154C3.14246 12.1397 3.14246 11.8548 3.3182 11.679L10.2801 4.71709L11.3408 5.77775L5.87129 11.2472L20.9999 11.2475L20.9998 12.7475L5.87135 12.7472Z\" fill=\"#1D1D1D\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol